import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Section, SectionHeading, iconMap } from './shared';
// 07 — CLAIM TYPE ROUTER · [Journey] [Lead Gen] [SEO/GEO]
// Five large route cards. services{title,description,features,link,icon}.
// Descriptive CTAs — never "Learn More".
const services = [{
  title: 'I was injured at work',
  description: 'Workers’ compensation, common-law claims and injuries on WA worksites, including FIFO and construction.',
  features: ['Statutory & common-law rights', 'Income & medical support'],
  link: '/workers-compensation-lawyers-perth/',
  icon: 'work',
  cta: 'Explore Work Injury Claims'
}, {
  title: 'I was injured in a road accident',
  description: 'Drivers, passengers, riders, cyclists and pedestrians injured on Western Australian roads.',
  features: ['All road users', 'Time limits may apply'],
  link: '/car-accident-lawyers-perth/',
  icon: 'road',
  cta: 'Explore Road Accident Claims'
}, {
  title: 'I was injured in a public or private place',
  description: 'Public liability claims — slips, falls, dog attacks and injuries on premises owned by others.',
  features: ['Public & private premises', 'Duty of care'],
  link: '/public-liability-lawyers-perth/',
  icon: 'public',
  cta: 'Explore Public Liability Claims'
}, {
  title: 'I or a family member suffered a serious injury',
  description: 'Catastrophic injury support for individuals and families facing life-changing circumstances.',
  features: ['Experienced, human support', 'Home & hospital appointments'],
  link: '/catastrophic-injury-lawyers-perth/',
  icon: 'serious',
  cta: 'Explore Serious Injury Claims'
}, {
  title: 'I lost a family member',
  description: 'Fatal accident and dependency claims for families who have lost a loved one in a workplace or road incident.',
  features: ['Compassionate, private support', 'Dependency & loss-of-support claims'],
  link: '/road-accidents/fatal-accident-claims/',
  icon: 'family',
  cta: 'Explore Fatal Injury Claims'
}, {
  title: 'I am not sure which option applies',
  description: 'Tell us what happened in plain English and we will help identify the right next step.',
  features: ['No legal knowledge needed', 'Guided, confidential'],
  link: '#quick-claim-form',
  icon: 'unsure',
  cta: 'Help Me Choose'
}];
export function ClaimRouter() {
  return <Section id="claim-router" className="bg-paper" data-id="element-59">
      <SectionHeading eyebrow="Find your path" title="What Happened?" intro="Choose the option that best matches your situation. Every path reaches a lawyer who can help — including if you are unsure." data-id="element-60" />

      <ul className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-61">
        {services.map(s => {
        const Icon = iconMap[s.icon];
        return <li key={s.title} className="h-full" data-id="element-62">
              <a href={s.link} className="group flex h-full flex-col rounded-card border border-ink/5 bg-paper p-7 shadow-card transition-all duration-200 hover:-translate-y-1 hover:shadow-card-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal" data-id="element-63">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-btn bg-forest/8 text-forest transition-colors group-hover:bg-forest group-hover:text-paper" data-id="element-64">
                  <Icon aria-hidden="true" className="h-6 w-6" strokeWidth={1.5} data-id="element-65" />
                </span>
                <h3 className="mt-5 text-h4 font-semibold text-ink" data-id="element-66">
                  {s.title}
                </h3>
                <p className="mt-2 text-body text-slate" data-id="element-67">{s.description}</p>
                <ul className="mt-4 space-y-1.5" data-id="element-68">
                  {s.features.map(f => <li key={f} className="flex items-center gap-2 text-small text-slate" data-id="element-69">
                      <span className="h-1 w-1 rounded-full bg-gold" aria-hidden="true" data-id="element-70" />
                      {f}
                    </li>)}
                </ul>
                <span className="mt-auto inline-flex items-center gap-2 pt-6 text-body font-semibold text-signal" data-id="element-71">
                  {s.cta}
                  <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={1.75} data-id="element-72" />
                </span>
              </a>
            </li>;
      })}
      </ul>
    </Section>;
}